<template>
  <div class="radar"  >
    <div class="view"></div>
      <div  class="radarDial" :style="'transform:rotateZ('+north+'deg);'">
        <div class="north"><div class="compass">N</div>
      </div>
      <div class="targetHolder" :style="'transform:rotateZ('+(rotation+45)+'deg);'">
        <div class="target" :style="'top:'+targetDistance+'px'"></div>
      </div>
    </div>
    <div class="radarText">RADAR</div>
  </div>
</template>

<script>
// @ is an alias to /src




export default {
  name: "Radar",
  props:{
    north:{default:0},
    rotation:{default:0},
    distance:{default:0}
  },
  components: {
   
  },
  data() {
    return {
      
    };
  },
  computed:{ 
    targetDistance(){
      return Math.max(-5,(95*50-this.distance)/50)
    }
  },
  methods:{
   
   
  },
  watch:{
    
  }
};
</script>

<style lang="scss">
.radar{
  position:absolute;
  width:204px;
  height:204px;
  border-radius:50%;
  left:10px;
  top: 690px;
  overflow:hidden;
  .radarDial{
  position:absolute;
  width:200px;
  height:200px;
  border-radius:50%;
  border:solid #65e8d9 2px;

  }
  .targetHolder{
   position:absolute;
   left:3px;
   top:3px;
   width:190px;
   height:190px;
   border-radius:50%;
   border:solid #65e8d9 2px;
   
  }
  .radarText{
    font-size: 20px;
    color: #fff;
    margin-top: 150px;
  }
  .target{
    position:absolute;
    left:97px;
    top:20px;
    width:12px;
    height:12px;
    border-radius:50%;
    background-color:#e8a265;
   
  }
  .north{
     position:absolute;
    left:98px;
    top:0px;
    width:4px;
    height:10px;
    border-radius:50%;
    background-color:#65e8d9;
  }
  .compass{
     position:absolute;
     text-align:center;
     width:24px;
     top:10px;
     left:-10px;
     color:#65e8d9;
     
  }
  .view{
     position:absolute;
     text-align:center;
     width:100px;
     height:100px;
     transform-origin: 100% 100%;
     transform:rotate(45deg);
     
     background-color:#65e8d933;
  }
}

</style>